export const validateSignUpForm = (values) => {
  const errors = {};

  // First Name validation
  if (!values.firstName) {
    errors.firstName = 'İsim gereklidir';
  } else if (values.firstName.length < 2) {
    errors.firstName = 'İsim en az 2 karakter olmalıdır';
  }

  // Last Name validation
  if (!values.lastName) {
    errors.lastName = 'Soyisim gereklidir';
  } else if (values.lastName.length < 2) {
    errors.lastName = 'Soyisim en az 2 karakter olmalıdır';
  }

  // Phone validation
  if (!values.phone) {
    errors.phone = 'Telefon numarası gereklidir';
  } else if (!/^[0-9]{10}$/.test(values.phone)) {
    errors.phone = 'Geçerli bir telefon numarası giriniz (10 haneli)';
  }

  // Email validation
  if (!values.email) {
    errors.email = 'E-posta adresi gereklidir';
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = 'Geçerli bir e-posta adresi giriniz';
  }

  // Password validation
  if (!values.password) {
    errors.password = 'Şifre gereklidir';
  } else if (values.password.length < 6) {
    errors.password = 'Şifre en az 6 karakter olmalıdır';
  }

  // Confirm Password validation
  if (!values.confirmPassword) {
    errors.confirmPassword = 'Şifre tekrarı gereklidir';
  } else if (values.confirmPassword !== values.password) {
    errors.confirmPassword = 'Şifreler eşleşmiyor';
  }

  if (!values.acceptedTerms) {
    errors.acceptedTerms = 'Kayıt olmak için Kullanıcı ve Hizmet Sözleşmesini kabul etmelisiniz';
  }

  return errors;
};

export const validateSignInForm = (values) => {
  const errors = {};

  // Email validation
  if (!values.email) {
    errors.email = 'E-posta adresi gereklidir';
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = 'Geçerli bir e-posta adresi giriniz';
  }

  // Password validation
  if (!values.password) {
    errors.password = 'Şifre gereklidir';
  } else if (values.password.length < 6) {
    errors.password = 'Şifre en az 6 karakter olmalıdır';
  }

  return errors;
};

export const validateuserUpdate = (formValues) => {
  let errors = {};

  if (!formValues.firstName) {
    errors.firstName = 'İsim boş bırakılamaz';
  }
  if (!formValues.lastName) {
    errors.lastName = 'Soyisim boş bırakılamaz';
  }
  if (!formValues.phone) {
    errors.phone = 'Telefon boş bırakılamaz';
  } else if (!/^\+90\s?(5\d{2})\s?\d{3}\s?\d{2}\s?\d{2}$/.test(formValues.phone)) {
    errors.phone = '+90 5XX XXX XX XX';
  }

  return errors;
};


export const validateAddresAdd = (formValues) => {
  let errors = {};

  if (!formValues.province) {
    errors.province = 'İl bilgisi boş bırakılamaz';
  }
  if (!formValues.district) {
    errors.district = 'İlçe bilgisi boş bırakılamaz';
  }
  if (!formValues.detail) {
    errors.detail = 'Adres detayı boş bırakılamaz';
  }
  if (!formValues.postalCode) {
    errors.postalCode = 'Posta kodu boş olamaz';
  }
  if (!/^\d+$/.test(formValues.postalCode)) {
    errors.postalCode = 'Posta kodu sadece sayılardan oluşmalıdır';
  }
  if (!formValues.type) {
    errors.type = 'Adres tipi boş olamaz';
  }
  return errors;
};


export const validateCompany = (formValues) => {
  let errors = {};

  if (!formValues.name) {
    errors.name = ' Şirket isim boş bırakılamaz';
  }
  if (!formValues.identifier) {
    errors.identifier = 'Boş bırakılamaz';
  } else if (formValues.identifier.length > 11) {
    errors.identifier = 'En fazla 11 hane';
  }


  return errors;
};

export const validatePlaceProductTrigger = (formValues) => {
  let errors = {};

  if (!formValues.baseKey) {
    errors.baseKey = 'Kaynak pazaryeri/e-ticaret seçilmelidir';
  }

  return errors;
};

export const validatePlaceProductDefinationRule = (formValues) => {
  let errors = {};

  // 0 geçerlidir: kullanıcı fiyatı kaynak pazaryeriyle birebir aynı tutmak isteyebilir.
  if (formValues.figure === '' || formValues.figure === null || formValues.figure === undefined) {
    errors.figure = 'Boş bırakılamaz';
  } else if (isNaN(Number(formValues.figure)) || Number(formValues.figure) < 0) {
    errors.figure = "0 veya daha büyük bir sayı olmalı";
  }

  return errors;
};

export const validatePrintTemplateSetting = (formValues) => {
  let errors = {};

  if (formValues.taxNumber && formValues.taxNumber.length > 11) {
    errors.taxNumber = 'En fazla 11 hane';
  }

  return errors;
};


export const validateChangePassword = (formValues) => {
  let errors = {};

  if (!formValues.code) {
    errors.code = 'kod boş bırakılamaz';
  } else if (!formValues.code) {
    errors.code = 'Invalid code ';
  }
  if (!formValues.password) {
    errors.password = 'Şifre boş bırakılamaz';
  } else if (formValues.password.length < 6) {
    errors.password = 'Password must be at least 6 characters long';
  }
  if (!formValues.rePassword) {
    errors.rePassword = 'Lütfen şifrenizi tekrar giriniz';
  } else if (formValues.rePassword !== formValues.password) {
    errors.rePassword = 'Passwords do not match';
  }
  if (formValues.rePassword != formValues.password) {
    errors.rePassword = 'Şifreler eşleşmiyor';
    errors.password = 'Şifreler eşleşmiyor';
  }

  return errors;
};


export const validateAddInvoices = (formValues) => {
  let errors = {};

  if (!formValues.customerData) {
    errors.customerData = 'Müşteri boş bırakılamaz';
  } else if (!formValues.customerData) {
    errors.customerData = 'Invalid customer ';
  }
  if (!formValues.issueDate) {
    errors.issueDate = 'Düzenleme tarihi boş olamaz';
  } else if (!formValues.issueDate) {
    errors.issueDate = 'Invalid date ';
  }
  if (!formValues.paymentMeansCode) {
    errors.paymentMeansCode = 'Ödeme yöntemi boş olamaz';
  }
  if (!formValues.type) {
    errors.type = 'Fatura türü boş bırakılamaz';
  }
  if (!formValues.number) {
    errors.number = 'Fatura numarası boş bırakılamaz';
  }

  if (!formValues.orderNumber) {
    errors.orderNumber = 'Sipariş numarası boş bırakılamaz';
  }
  if (!formValues.currencyCode) {
    errors.currencyCode = 'Para birimi boş bırakılamaz';
  }
  if (!formValues.status) {
    errors.status = 'Durum boş bırakılamaz';
  }
  if (!formValues.paymentDueDate) {
    errors.paymentDueDate = 'Ödeme vade tarihi boş bırakılamaz';
  }
  if (!formValues.note) {
    errors.note = 'Açıklama boş bırakılamaz';
  }
  if (!formValues.recordType) {
    errors.recordType = 'Fatura kayıt tipi boş bırakılamaz';
  }


  return errors;
};






export const validateAddInvoicesCustomer = (formValues) => {
  let errors = {};

  if (!formValues.name) {
    errors.name = 'isim boş bırakılamaz';
  } else if (!formValues.name) {
    errors.name = 'Invalid name ';
  }
  if (!formValues.mail) {
    errors.mail = 'Eposta boş olamaz';
  } else if (!/\S+@\S+\.\S+/.test(formValues.mail)) {
    errors.mail = 'Invalid Email Address';
  }
  if (!formValues.phone) {
    errors.phone = 'Telefon numarası boş olamaz';
  }
  if (!formValues.identifier) {
    errors.identifier = 'Kimlik Numarası boş bırakılamaz';
  } else if (formValues.identifier.length > 20) {
    errors.identifier = 'Hatalı kimlik no ';
  }
  if (!formValues.detail) {
    errors.detail = 'Adres boş bırakılamaz';
  } else if (!formValues.detail) {
    errors.detail = 'Invalid address ';
  }
  if (!formValues.country) {
    errors.country = 'Ülke boş bırakılamaz';
  }
  if (!formValues.district) {
    errors.district = 'İlçe birimi boş bırakılamaz';
  }
  if (!formValues.province) {
    errors.province = 'İl  boş bırakılamaz';
  }
  // if (!formValues.customerType) {
  //   errors.customerType = 'Müşteri Türü boş olamaz';
  // } else if (!formValues.customerType) {
  //   errors.customerType = 'Invalid customerType ';
  // }


  return errors;
};


export const validateUpdateInvoices = (formValues) => {
  let errors = {};
  if (!formValues.customerData) {
    errors.customerData = 'Müşteri boş bırakılamaz';
  } else if (!formValues.customerData) {
    errors.customerData = 'Invalid customer ';
  }
  if (!formValues.issueDate) {
    errors.issueDate = 'Düzenleme tarihi boş olamaz';
  } else if (!formValues.issueDate) {
    errors.issueDate = 'Invalid date ';
  }
  if (!formValues.paymentMeansCode) {
    errors.paymentMeansCode = 'Ödeme yöntemi boş olamaz';
  }
  if (!formValues.type) {
    errors.type = 'Fatura türü boş bırakılamaz';
  }
  if (!formValues.number) {
    errors.number = 'Fatura numarası boş bırakılamaz';
  }

  // if (!formValues.orderNumber) {
  //   errors.orderNumber = 'Sipariş numarası boş bırakılamaz';
  // } 
  if (!formValues.currencyCode) {
    errors.currencyCode = 'Para birimi boş bırakılamaz';
  }
  if (!formValues.status) {
    errors.status = 'Durum boş bırakılamaz';
  }
  if (!formValues.paymentDueDate) {
    errors.paymentDueDate = 'Ödeme vade tarihi boş bırakılamaz';
  }
  if (!formValues.note) {
    errors.note = 'Açıklama boş bırakılamaz';
  }
  if (!formValues.recordType) {
    errors.recordType = 'Fatura kayıt tipi boş bırakılamaz';
  }
  return errors;
};



export const validateMarketplaceAccount = (formValuesArray) => {
  let errorsArray = [];


  const formArray = Array.isArray(formValuesArray) ? formValuesArray : [formValuesArray];


  formArray.forEach((formValues, index) => {
    let errors = {};

    if (!formValues.value) {
      errors.type=formValues.type;
      errors.valueId=formValues.valueId;
      errors.marketplaceId = formValues.marketplaceId;
      errors.value = 'Bu alan boş bırakılamaz';
    } else if (!formValues.value) {
      errors.type=formValues.type;
      errors.valueId=formValues.valueId;
      errors.marketplaceId = formValues.marketplaceId;
      errors.value = 'Invalid value';
    }


    errorsArray[index] = errors;
  });

  return errorsArray;
};
export const validateInvoiceLine = (formValuesArray) => {
  let errorsArray = [];
  let hasError = false;
  (formValuesArray.invoiceLines).map((data, index) => {
    let errors = {};

    // if (!data.unitCode) {
    //   errors.unitCode = 'Stok Kodu boş bırakılamaz';
    //   hasError = true;
    // }

    if (!data.inventoryCard) {
      errors.inventoryCard = 'Ürün Adı boş bırakılamaz';
      hasError = true;
    }

    if (!data.quantity) {
      errors.quantity = 'Miktar boş bırakılamaz';
      hasError = true;
    }

    if (!data.price) {
      errors.price = 'Birim fiyat boş bırakılamaz';
      hasError = true;
    }

    if (!data.description) {
      errors.description = 'Kalem açıklaması boş bırakılamaz';
      hasError = true;
    }

    if (data.vatRate === undefined || data.vatRate === null || data.vatRate === '') {
      errors.vatRate = 'KDV boş bırakılamaz';
      hasError = true;
    }


    if (data.discountRate === undefined || data.discountRate === null || data.discountRate === '') {
      errors.discountRate = 'İskonto boş bırakılamaz';
      hasError = true;
    }

    errorsArray[index] = errors;
  });
  if (!hasError) { errorsArray = {}; }
  return errorsArray;
};



export const validateProduct = (details, barcode, piyasaFiyati, satisFiyati, description) => {
  const errors = {};

  // Ürün Adı Kontrolü
  if (!details.productName || details.productName.trim() === '') {
    errors.productName = 'Ürün Adı boş bırakılamaz';
  }

  // Model Kodu Kontrolü
  // if (!details.modelCode || details.modelCode.trim() === '') {
  //   errors.modelCode = 'Model Kodu boş bırakılamaz';
  // }

  // Satıcı Barcode Kontrolü
  // if (!details.supplierBarcode || details.supplierBarcode.trim() === '') {
  //   errors.supplierBarcode = 'Satıcı Barcode boş bırakılamaz';
  // }

  // Stok Kontrolü
  if (!details.stock || isNaN(details.stock) ) {
    errors.stock = 'Stok geçerli bir sayı olmalıdır';
  }

  // Barkod Kontrolü
  // if (!barcode || barcode.trim() === '') {
  //   errors.barcode = 'Barkod boş bırakılamaz';
  // }

  // Piyasa Fiyatı Kontrolü
  // if (!piyasaFiyati || isNaN(parseFloat(piyasaFiyati)) || parseFloat(piyasaFiyati) <= 0) {
  //   errors.piyasaFiyati = 'Piyasa Fiyatı geçerli bir sayı olmalıdır';
  // }

  // Satış Fiyatı Kontrolü
  // if (!satisFiyati || isNaN(parseFloat(satisFiyati)) || parseFloat(satisFiyati) <= 0) {
  //   errors.satisFiyati = 'Satış Fiyatı geçerli bir sayı olmalıdır';
  // }

  // Kategori Kontrolü
  if (!details.category || details.category === '') {
    errors.category = 'Kategori seçimi zorunludur';
  }

  // Marka Kontrolü
  if (!details.brand || details.brand === '') {
    errors.brand = 'Marka seçimi zorunludur';
  }

  // Detaylı açıklama kontrolü
  // if (!description || description.trim() === '') {
  //   errors.description = 'Detaylı açıklama zorunludur';
  // }

  return errors;
};

export const validateEcommercePlaceAccount = (formValuesArray) => {
  let errorsArray = [];

  const formArray = Array.isArray(formValuesArray) ? formValuesArray : [formValuesArray];


  formArray.forEach((formValues, index) => {
    let errors = {};

    // Sadece "key" tipindeki alanlar zorunlu, "settings" tipindeki alanlar opsiyonel
    if (formValues.type === "key" && !formValues.value) {
      errors.type=formValues.type;
      errors.valueId=formValues.valueId;
      errors.ecommercePlaceId = formValues.ecommercePlaceId;
      errors.value = 'Bu alan boş bırakılamaz';
    }


    errorsArray[index] = errors;
  });

  return errorsArray;
};

export const validateInvoiceIntegratorAccount = (formValuesArray) => {
  let errorsArray = [];


  const formArray = Array.isArray(formValuesArray) ? formValuesArray : [formValuesArray];


  formArray.forEach((formValues, index) => {
    let errors = {};
    if (!formValues.value) {
      errors.type=formValues.type;
      errors.valueId=formValues.valueId;
      errors.integratorId = formValues.InvoiceIntegratorId;
      errors.value = 'Bu alan boş bırakılamaz';
    } else if (!formValues.value) {
      errors.type=formValues.type;
      errors.valueId=formValues.valueId;
      errors.integratorId = formValues.InvoiceIntegratorId;
      errors.value = 'Invalid value';
    }


    errorsArray[index] = errors;
  });

  return errorsArray;
};
export const validateBrandAdd = (formValues) => {
  let errors = {};
  if (!formValues.name) {
    errors.name = 'isim bilgisi boş bırakılamaz';
  }
  return errors;
};

export const validateCategoryAdd = (formValues) => {
  let errors = {};
  if (!formValues.name) {
    errors.name = 'isim bilgisi boş bırakılamaz';
  }
  if (formValues.vatRate == null) {
    errors.vatRate = 'KDV bilgisi boş bırakılamaz';
  }
  return errors;
};

export const validateExcelAdd = (formValues) => {
  let errors = {};
  if (!formValues.type) {
    errors.type = 'Tip bilgisi boş bırakılamaz';
  }
  if (!formValues.base64) {
    errors.base64 = 'Dosya Eklenmedi';
  }
  return errors;
};


export const validateXMLAdd = (formValues, activeStep) => {

  let errors = {};

  if (activeStep == 0) {

    if (!formValues.providerId) {
      errors.providerId = 'Tedarikçi bilgisi boş bırakılamaz';
    }
    if (!formValues.name) {
      errors.name = 'isim bilgisi boş bırakılamaz';
    }
    if (!formValues.link) {
      errors.link = 'Link bilgisi boş bırakılamaz';
    }

  }
  if (activeStep == 1) {

    if (!formValues.productProviderGeneralSetting.stockCritical) {
      errors.stockCritical = 'Kritik Stok Sınırı bilgisi boş bırakılamaz';
    }
  }
  return errors;
};


export const validateXmlUser = (formValues) => {
  let errors = {};
  if (!formValues.name) {
    errors.name = 'İsim boş geçilemez';
  }
  if (!formValues.surName) {
    errors.surName = 'İsim boş geçilemez';
  }
  if (!formValues.identifier) {
    errors.identifier = 'Tc';
  }
  if (!formValues.phone) {
    errors.phone = 'Telefon  boş geçilemez';
  }
  if (!formValues.userName) {
    errors.userName = 'Kullanıcı Adı boş geçilemez';
  }
  if (!formValues.password) {
    errors.password = 'Şifre boş geçilemez';
  } else if (formValues.password.length < 4) {
    errors.password = 'En az 4 karakter olmalı';
  }
  return errors;
};



export const validateForgotPassword = (formValues) => {
  let errors = {};

  if (!formValues.code) {
    errors.code = 'kod boş bırakılamaz';
  }

  return errors;
};



export const validateProductUpdate = (details) => {
  const errors = {};
  // Kategori Kontrolü
  if (!details.categoryId || details.categoryId === '') {
    errors.category = 'Kategori seçimi zorunludur';
  }

  // Marka Kontrolü
  if (!details.brandId || details.brandId === '') {
    errors.brand = 'Marka seçimi zorunludur';
  }
  // Marka Kontrolü
  if (!details.title || details.title === '') {
    errors.title = 'Ürün adı zorunlu';
  }
  // if (!details.stockCode || details.stockCode === '') {
  //   errors.stockCode = 'Model kodu zorunlu';
  // }
  // if (!details.supplierBarcode || details.supplierBarcode === '') {
  //   errors.supplierBarcode = 'Barkod zorunlu';
  // }
  // if (!details.quantity || details.quantity === '') {
  //   errors.quantity = 'Stok zorunlu';
  // }
  return errors;
};
